import { forwardRef } from 'react';
import { Chip } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { type CheckMyQuizStatus } from '@/hooks/useCheckMyQuiz';
import { DetailHeroCard } from '@/shared/components';
import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { type PlanType } from '@/types';
import { type MapTemplateType, MapTemplateTypeLocaleKey } from '@/types/MapTemplate';
import { HeroContent } from './components/HeroCard/components/HeroContent/HeroContent';
import { HeroImage } from './components/HeroCard/components/HeroImage/HeroImage';
import { useHeroCardData } from './components/HeroCard/hooks/useHeroCardData';
export type QuizDetailHeroCardProps = {
  quizData: QuizSetDetailsRes;
  meStatus: CheckMyQuizStatus;
  className?: string;
};
export const QuizDetailHeroCard = forwardRef<HTMLDivElement, QuizDetailHeroCardProps>(({
  quizData,
  meStatus,
  className
}, ref) => {
  const {
    t
  } = useTranslation(['common']);
  // Transform data using hook
  const heroCardData = useHeroCardData(quizData, meStatus);
  const planBadgeProps = {
    isBadgeVisible: quizData.templatePlanType !== 'FREE',
    planType: quizData.templatePlanType as Exclude<PlanType, 'FREE'>
  };
  return <DetailHeroCard ref={ref} className={className} image={<WithPlanBadge {...planBadgeProps}>
          <HeroImage data={heroCardData.image} className="rounded-md" />
        </WithPlanBadge>} mobileImage={<WithPlanBadge {...planBadgeProps}>
          <HeroImage data={heroCardData.image} className="rounded-md outline outline-[4px] outline-white" />
        </WithPlanBadge>} mobileImageAside={
  // 모바일에서만 이미지 우측 하단에 붙는 맵 타입 칩 (순서 풀이 등)
  <div className="mb-2xs flex shrink-0 items-end pb-2xs">
          <Chip size="sm" className="rounded-xs border border-alternative bg-neutral px-xs py-3xs text-caption-md-semibold">
            {t(MapTemplateTypeLocaleKey[heroCardData.image.type as MapTemplateType])}
          </Chip>
        </div>}>
      <HeroContent data={heroCardData} />
    </DetailHeroCard>;
});
QuizDetailHeroCard.displayName = 'QuizDetailHeroCard';